import { yupResolver } from '@hookform/resolvers/yup';
import has from 'lodash.has';
import { Box, Button, ChevronLeftIcon, Flex, FormControl, HStack, Link, Progress, Text, VStack } from 'native-base';
import React, { memo, useMemo } from 'react';
import { useContext } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { NavigationContext } from '../../../contexts';
import { object, string } from 'yup';
import { States } from '../../../utils';
import { DropDown } from '../../DropDown';
import Functions from '../../../utils/Functions';
const schema = object({
  propertyState: string().required('Please select property state')
});
const LocationInformation = _ref => {
  var _errors$propertyState;
  let {
    title,
    id,
    navigation: {
      current,
      back,
      next
    }
  } = _ref;
  const {
    type,
    logUserEvent,
    onSelected,
    total,
    review,
    step,
    setStep
  } = useContext(NavigationContext);
  const {
    propertyState
  } = useMemo(() => review[step], [review, step]);
  const {
    control,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: {
      propertyState
    }
  });
  const onSubmit = data => {
    var _States$find;
    logUserEvent({
      type,
      action: `${type}FormSubmitClicked`
    });
    var stateName = (_States$find = States.find(state => state.value === data.propertyState)) === null || _States$find === void 0 ? void 0 : _States$find.label;
    onSelected({
      value: {
        propertyState: data.propertyState,
        propertyStateName: stateName
      },
      navigation: {
        action: 'next',
        next,
        back,
        current
      }
    });
  };
  return /*#__PURE__*/React.createElement(Flex, {
    wrap: "wrap",
    direction: "column",
    align: "center",
    key: id
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    color: 'blue.1000',
    fontSize: '4xl',
    fontWeight: 'light',
    accessibilityLabel: title,
    testID: `radio-card-group-${title}`,
    mb: "5"
  }, title)), /*#__PURE__*/React.createElement(VStack, {
    w: {
      sm: '100%',
      base: '100%',
      md: undefined,
      lg: undefined
    },
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(VStack, {
    space: "2xs",
    w: "100%",
    mb: "8"
  }, /*#__PURE__*/React.createElement(Progress, {
    value: Math.ceil(100 / total * current),
    h: "2",
    bg: "white.700",
    borderColor: "border.light",
    borderWidth: "0.25",
    _filledTrack: {
      bg: '#1B68A5'
    },
    accessibilityLabel: 'progress bar',
    accessibilityRole: "progressbar",
    testID: `radio-card-group-${title}`
  }), /*#__PURE__*/React.createElement(Text, {
    textAlign: "right",
    fontFamily: "body",
    fontWeight: "medium",
    fontSize: "sm",
    color: "navyblue.500",
    accessibilityLabel: `step ${current} out of ${total}`
  }, `${current}/${total}`)), /*#__PURE__*/React.createElement(VStack, {
    w: {
      base: '100%',
      sm: '100%',
      md: '2xl',
      lg: '2xl'
    },
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(FormControl, {
    h: "28",
    isInvalid: has(errors, 'propertyState'),
    mb: {
      base: 0,
      md: 2,
      lg: 2
    },
    w: {
      sm: '100%',
      md: 280,
      lg: 280
    }
  }, /*#__PURE__*/React.createElement(FormControl.Label, {
    accessibilityLabel: "property state"
  }, "PROPERTY STATE"), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    render: _ref2 => {
      let {
        field: {
          onChange,
          value
        }
      } = _ref2;
      return /*#__PURE__*/React.createElement(DropDown, {
        accessibilityLabel: "please select property state",
        w: {
          base: '100%',
          sm: '100%',
          md: 280,
          lg: 280
        },
        selectedValue: value,
        placeholder: 'Select',
        onValueChange: onChange,
        list: States
      });
    },
    name: "propertyState",
    defaultValue: propertyState
  }), /*#__PURE__*/React.createElement(FormControl.ErrorMessage, {
    accessibilityLabel: 'Please select property state'
  }, (_errors$propertyState = errors.propertyState) === null || _errors$propertyState === void 0 ? void 0 : _errors$propertyState.message)))), /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    my: "5",
    w: {
      base: '100%',
      sm: '100%',
      md: '2xl',
      lg: '2xl'
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "center",
    alignItems: "center",
    space: "1"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    color: "blue.400",
    size: "5"
  })), /*#__PURE__*/React.createElement(Link, {
    onPress: () => {
      logUserEvent({
        type,
        action: `${type}locationInfoBackClicked`
      });
      setStep(back);
    },
    accessibilityLabel: "back",
    accessibilityRole: "link",
    _text: {
      fontSize: 'lg',
      color: 'blue.400',
      textDecoration: 'none'
    },
    testID: "locationInfo-back-button"
  }, "Back")), /*#__PURE__*/React.createElement(Button, {
    variant: "freedom",
    w: "140",
    _text: {
      fontWeight: 'bold',
      fontSize: 'lg'
    },
    accessibilityLabel: "Update",
    accessibilityRole: "button",
    onPress: handleSubmit(onSubmit),
    isDisabled: !Functions.isEmpty(errors),
    _disabled: {
      bg: 'grey.200'
    },
    testID: "locationInfo-update-button"
  }, "Next")));
};
export default /*#__PURE__*/memo(LocationInformation);
//# sourceMappingURL=index.js.map